import { useEffect } from "react";
import { activeModule, setActiveModule, ActiveModule } from "../providers/active-module";
import { useConfig } from "../providers/config";
import { queryClient } from "../config/query-client";

const appActiveModule = process.env.REACT_APP_ACTIVE_MODULE as ActiveModule["current"];

const useSetActiveModuleOnInit = () => {
  const config = useConfig();

  const handleClearCache = async () => {
    await queryClient.clear();
  };

  useEffect(() => {
    if (!config.moduleOnInit) return;

    if (activeModule !== appActiveModule) {
      const newActiveModule = {
        current: config.moduleOnInit,
        isModuleInitialized: true,
      } as ActiveModule;

      setActiveModule(newActiveModule);
      handleClearCache();
    }
  }, [config.moduleOnInit]);
};

export default useSetActiveModuleOnInit;
